"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
/**
 * Makeblock 接口服务
 *
 * @author HUANGE
 * @date 2020-03-16
 * @class MakeblockServiceApi
 */
class MakeblockRequest {
    /**
     * Creates an instance of MakeblockServiceApi.
     * @author HUANGE
     * @date 2020-03-10
     */
    constructor() {
        this.axios = axios_1.default.create({
            timeout: 30000,
            // withCredentials: true,
            transformRequest: [
                (data) => {
                    return JSON.stringify(data);
                }
            ],
            transformResponse: [
                (data) => {
                    return JSON.parse(data);
                }
            ]
        });
        this.interceptors();
    }
    /**
     * 默认拦截器
     *
     * @author HUANGE
     * @date 2020-03-10
     * @private
     */
    interceptors() {
        // 请求拦截器
        this.axios.interceptors.request.use((config) => {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            return Promise.resolve(config);
        }, (error) => {
            return Promise.reject(error);
        });
        // 响应拦截器
        this.axios.interceptors.response.use((response) => {
            const { status, data } = response;
            if (status === 200 && data.code === 0) {
                return Promise.resolve(data.data);
            }
            return Promise.reject(data);
        }, (error) => {
            return Promise.reject(error);
        });
    }
    /**
     * 使用配置生成接口
     *
     * @author HUANGE
     * @date 2020-03-10
     * @param {Record<string, string>} config
     */
    apis(config) {
        const that = this;
        const apiKeys = Object.keys(config);
        const apis = {};
        apiKeys.forEach((key) => {
            const cfg = config[key].split(' ');
            let [url, method = 'GET'] = cfg;
            method = method.toLowerCase();
            Object.defineProperty(apis, key, {
                value(...args) {
                    const mt = method.toUpperCase();
                    if (mt === 'GET') {
                        return that.axios.get(url, ...args);
                    }
                    if (mt === 'POST') {
                        return that.axios.post(url, ...args);
                    }
                    if (mt === 'PUT') {
                        return that.axios.put(url, ...args);
                    }
                    if (mt === 'PATCH') {
                        return that.axios.patch(url, ...args);
                    }
                    if (mt === 'DELETE') {
                        return that.axios.delete(url, ...args);
                    }
                    const cfg = Object.assign({ url, method: method }, args);
                    return that.axios(cfg);
                }
            });
        });
        return apis;
    }
}
exports.default = MakeblockRequest;
